import React, { createElement } from "react";

import "../styles/search.scss";
import { ReactNode } from "react";
import SearchLogo from "./../assets/images/search_log.png";
import { pageInfo } from './../models/system';
import { search, searchResult, showingResult, savingResult, ActivityResult } from "./../apis/api";
import { createBrowserHistory } from "history";
import { Pager } from "./components/Pager";
export class Search extends React.Component {
    state = { pagecount: 0, page: 0 as number, key: null as string | null, result: null as null | pageInfo<searchResult> };
    async componentDidMount(): Promise<void> {
        let history = createBrowserHistory();
        let s = history.location.state as { query: string }
        this.setState({ key: s.query });
        let r = await search(s.query, this.state.page);
        this.setState({ "result": r, pagecount: Math.ceil(r.pageCount / 20) });
    }

    getText(v: string): string {
        if (v == null) return "";
        let c = document.createElement("div");
        c.innerHTML = v.replace(RegExp("&lt;", "g"), "<").replace(RegExp("&gt;", "g"), ">");

        return c.innerText;
    }
    set_page: (page: number) => void = (page: number) => {

        search(this.state.key, page).then(x => {

            this.setState({ "result": x, page: page });
        });
    }


    renderContent(x: searchResult): ReactNode {
        if (x.type === 1 || x.type === 4)
            return <p className="search-context">{this.getText(x.description)}</p>
        else if (x.type === 2) {

            let s = x as showingResult;
            return (
                <>
                    <div className="attachinfo">
                        <div>
                            <span>展览地点：</span>
                            <span>{s.address}</span>
                        </div>
                        <div>
                            <span>展览时间：</span>
                            <span>{s.time}</span>
                        </div>
                    </div>
                    <p className="search-context">{this.getText(x.description)}</p>
                </>
            )
        }
        else if (x.type === 3) {
            let s = x as savingResult;
            return (
                <>
                    <div className="attachinfo">
                        <div>
                            <span>年代：</span>
                            <span>{s.time}</span>
                        </div>
                        <div>
                            <span>规格：</span>
                            <span>{s.kind}</span>
                        </div>
                    </div>
                    <p className="search-context">{this.getText(x.description)}</p>
                </>
            )
        }
        else if (x.type === 5) {
            let s = x as ActivityResult;
            return (
                <>
                    <div className="attachinfo">
                        <div>
                            <span>时间：</span>
                            <span>{s.time}</span>
                        </div>
                        <div>
                            <span>地点：</span>
                            <span>{s.address}</span>
                        </div>
                        <div>
                            <span>主办：</span>
                            <span>{s.host}</span>
                        </div>
                    </div>
                    <p className="search-context">{this.getText(x.description)}</p>
                </>
            )
        }
        else return <p className="search-context">{this.getText(x.description)}</p>
    }
    render(): ReactNode {
        return (
            <section className="headerinfo bg search">
                <div className="contactUs">
                    <div className="contactUs_title btn_title search_title ">搜索结果</div>
                    <div className="contactUs_content searchitem">

                        {this.state.result?.content.map(x =>

                            <>
                                <div className="list">【{x.type === 1 ? "资讯" : x.type === 2 ? "展览" : x.type === 3 ? "馆藏" : x.type === 4 ? "文创" : "活动"}】{x.title}</div>
                                <hr></hr>
                                {this.renderContent(x)}

                            </>
                        )}

                    </div>
                </div>
                <Pager pageCount={this.state.pagecount} pageSize={10} curpage={0} onNavigatePage={this.set_page}></Pager>

            </section>
        )
    }
}

